module.exports = __webpack_public_path__ + "img/m-banner-cookagaw-vi-VN.85b10850.jpg";